import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

function SquareButton ({ children, className, color, onClick, big, type, inactive, active }) {
  const buttonClassName = classNames(
    'btn',
    'btn-sq',
    { 'btn-primary': color === 'btn-primary' || color === 'primary' },
    { 'btn-white': color === 'btn-white' || color === 'white' },
    { 'btn-lightgray': color === 'btn-lightgray' || color === 'lightgray' },
    { 'btn-green': color === 'btn-green' || color === 'green' },
    { 'btn-red': color === 'btn-red' || color === 'red' },
    { 'btn-outlinePrimary': color === 'btn-outlinePrimary' || color === 'outlinePrimary' },
    { 'btn-outlineDark': color === 'btn-outlineDark' || color === 'outlineDark' },
    { 'btn-outlineWhite': color === 'btn-outlineWhite' || color === 'outlineWhite' },
    { 'btn-outlineLight': color === 'btn-outlineLight' || color === 'outlineLight' },
    big ? 'btn-sq--big' : null,
    inactive ? 'btn-inactive' : null,
    active ? 'active' : null,
    className
  )

  return (
    <button onClick={onClick} className={buttonClassName} type={type}>
      {children}
    </button>
  )
}

SquareButton.defaultProps = {
  color: 'btn-primary',
  onClick: null,
  big: false,
  type: 'button',
  inactive: false,
  active: false,
  className: null
}

SquareButton.propTypes = {
  /**
     * Controls the button's color (default 'btn-primary')
     * Options: 'btn-primary', 'btn-white', 'btn-lightgray', 'btn-outlinePrimary',
     *          'btn-outlineDark', 'btn-outlineWhite', 'btn-outlineLight'
     */
  color: PropTypes.oneOf([
    'btn-primary',
    'btn-white',
    'btn-lightgray',
    'btn-green',
    'btn-red',
    'btn-outlinePrimary',
    'btn-outlineDark',
    'btn-outlineWhite',
    'btn-outlineLight',
    'primary',
    'white',
    'lightgray',
    'green',
    'red',
    'outlinePrimary',
    'outlineDark',
    'outlineWhite',
    'outlineLight'
  ]),
  /**
     * Make square button bigger if set to true; defaults to false
     */
  big: PropTypes.bool,
  /**
     * OnClick event handler
     */
  onClick: PropTypes.func,
  /**
     * Controls if the button is active or inactive
     */
  inactive: PropTypes.bool,
  /**
     * Apply an active class if this is true
     */
  active: PropTypes.bool
}

export default SquareButton
